export default {
      id: "icon-arrow-up-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-arrow-up",
      toString: function () {
        return this.url;
      }
    }